(function( $ ){
  $.pictFrame = {};
  $.pictFrame.startAnims = [];
  $.pictFrame.stopAnims = [];
  $.pictFrame.fade = function(){
    $.pictFrame.startAnims.forEach(function(anim){
      anim();
    });
  };
  $.pictFrame.stop = function(){
    $.pictFrame.stopAnims.forEach(function(anim){
      anim();
    });
  };

  $.pictFrame.build = function(obj, opt){
    const $this = $(obj);
    let $wrapper = null;

    const options = {
      thumbnail: true,
      bg: false,
      fadeTiming: 1000,
      delayTiming: 2500
    }
    if (opt instanceof Object) {
      $.extend(options, opt);
    }
    init();

    return $this;

    function init() {
      $this.addClass('pict_frame');
      $wrapper = $this.wrap('<div class="wrap_pict_frame">').parent();
      $this.$thumbs = $this.children().each(function(idx, ele){
        $(ele).wrap('<div class="pict pict_'+idx+'">').parent().attr('data-idx', idx);
        if (options.bg) {
          const path = $(ele).attr('src');
          $(ele).parent().css({backgroundImage: 'url(' + path + ')'});
          $(ele).css({opacity: 0});
        }
      }).map(function(idx, ele){
        return $(ele).clone();
      });
      if (options.thumbnail) {
        $this.$wrapThumbs = $('<div class="pict_thumbs"></div>');
        $this.$thumbs.each(function(idx, ele){
          const $thumb = $(ele).wrap('<a class="pict_thumb'+ (idx == 0 ? ' active' : '') +'">').parent();
          $this.$wrapThumbs.append($thumb);
        });
        $wrapper.append($this.$wrapThumbs);
      }

      const fadeTiming = options.fadeTiming;
      const delayTiming = options.delayTiming;
      let fadeId = null;
      const fadeAnim = function() {
        fadeId = setInterval(function(){
          $this.children().first().animate({opacity: 0}, fadeTiming, 'linear', function(){
            const $pict = $(this);
            const $frame = $pict.parent();
            if (options.thumbnail) {
              const $thumbs = $this.$wrapThumbs.children();
              const pictIdx = $thumbs.length - 1 > Number($pict.attr('data-idx')) ? Number($pict.attr('data-idx')) + 1 : 0;
              $thumbs.removeClass('active').eq(pictIdx).addClass('active');
            }
            $pict.css({opacity: 1});
            $frame.append($pict);
          });
        }, (fadeTiming + delayTiming));
      }
      $.pictFrame.startAnims.push(fadeAnim);
      if (options.thumbnail) {
        const stopAnim = function() {
          clearInterval(fadeId);
        }
        $.pictFrame.stopAnims.push(stopAnim);
      }

      $wrapper.on('click', '.pict_thumb', function(e){
        e.preventDefault();
        $.pictFrame.stop();
        const $thumb = $(this);
        if ($thumb.hasClass('disabled')) return;
        const thumbIdx = $thumb.index();
        let aniFlag = true;
        const $thumbs = $('.pict_thumb');
        $thumbs.addClass('disabled').removeClass('active');
        $thumb.addClass('active');
        $this.children().each(function(idx, ele){
          const pictIdx =  $thumbs.length - 1 > Number($(ele).attr('data-idx')) ? Number($(ele).attr('data-idx')) + 1 : 0;
          if (aniFlag &&  thumbIdx != pictIdx) $this.append($(ele));
          if (thumbIdx == pictIdx) {
            aniFlag = false;
            $(ele).animate({opacity: 0}, (fadeTiming / 1), 'linear', function(){
              $(ele).removeAttr('style');
              $this.append($(ele));
              $thumbs.removeClass('disabled');
              $.pictFrame.fade();
            });
          }
        });
        $this.siblings().removeClass('active');
        $this.addClass('active');
      });
    }
  }
  $.fn.pictFrame = function( opt ) {
    if (this.length > 1) {
      return this.map(function(idx, ele){
        return $.pictFrame.build(ele, opt);
      });
    } else {
      return $.pictFrame.build(this, opt);
    }
  }

})( jQuery );



(function( $ ){

  $.fn.slideTabs = function( options ) {
    const $this = this;
    const $container = $this.closest('.header').siblings('.container');
    let $wrapTabs = null;
    let tabsWidth = 0;

    init();
    $this.slide = function(tabName){
      initPanels(tabName);
      slidePanel(tabName, false).promise().done(function(){
        $container.removeClass('anim');
        calcscrollPos();
      });
    };

    return $this;

    function init(){
      $wrapTabs = $this.wrap('<div class="wrap_slideTabs">').parent();
      $this.children().first().children().addClass('active');
      $this.children('.slideTab:not(.clone)').each(function(idx, ele){
        tabsWidth += $(ele).outerWidth();
      });
      const $cloneTabs = $this.children('.slideTab:not(.clone)').clone().map(function(idx, ele){return $(ele).addClass('clone');});
      const loopCount = Math.ceil( ($(window).width() * 8) / tabsWidth );
      for (let i = 0; i < loopCount-1; i++) {
        $cloneTabs.each(function(idx, ele){
          $this.append($(ele).clone());
        });
      }
      fixedCenterTab('HOME');

      $wrapTabs.on('scroll', function(e){
        const scLeft = this.scrollLeft;
        let tabWidth = 0;
        if (scLeft > tabsWidth *2) {
          tabWidth = firstDetach();
        } else if (scLeft < 150) {
          tabWidth = lastDetach();
        }
        this.scrollLeft = scLeft + tabWidth;
      });

      $this.on('click', '.slideTab', function(){
        const $tab = $(this);
        if ($tab.children().hasClass('active')) return;
        if ($tab.index() > 10 || $tab.index() < 5) {
          let scLeft = $wrapTabs[0].scrollLeft;
          let backLeft = 0;
          const loopCount = $tab.index() > 10 ? 4 : 2;
          const detachFunc = $tab.index() > 10 ? firstDetach : lastDetach;
          for (let i = 0; i < loopCount; i++) {
            backLeft += registerFunction(detachFunc);
          }
          $wrapTabs[0].scrollLeft = scLeft + backLeft;
        }
        const tabName = $tab.attr('data-tab');
        console.log(tabName, $tab[0]);
        initPanels(tabName);
        slidePanel(tabName, false).promise().done(function(){
          $container.removeClass('anim');
          calcscrollPos();
        });
      });

      let ts = [];
      let te = [];
      let tFlag = false;
      let $target = null;
      $container.on({
        'touchstart': function(e){
          if (tFlag) return;
          $target = $(e.target).closest('.panel');
          ts.x = getPageX(e);
          ts.y = getPageY(e);
          tFlag = true;
        },
        'touchmove': function(e){
          if (!tFlag) return;
          te.x = getPageX(e);
          te.y = getPageY(e);
        },
        'touchend': function(){
          if (!tFlag) return;
          const dir = ts.x < te.x; // true is right to left, false is left to right
          const distanceX = !!te.x ? Math.abs(ts.x - te.x) : 0;
          const distanceY = !!te.y ? Math.abs(ts.y - te.y) : 0;
          if (distanceX > 80 && distanceY < 30) {
            let inPanelName = null;
            const centerName = $target.attr('data-tab');
            const $centerPanel = $container.children('[data-tab="'+centerName+'"]');
            if (dir) { // swipe to left
              const $leftPanel = $centerPanel.prev()[0] ? $centerPanel.prev() : $container.children().last();
              inPanelName = $leftPanel.attr('data-tab');
            } else { // swipe to right
              const $rightPanel = $centerPanel.next()[0] ? $centerPanel.next() : $container.children().first();
              inPanelName = $rightPanel.attr('data-tab');
            }
            initPanels(inPanelName);
            const promise = slidePanel(inPanelName, dir);
            promise.done(function(){
              ts = [];
              te = [];
              tFlag = false;
              $target = null;
              $container.removeClass('anim');
              calcscrollPos()
            });
          } else {
            ts = [];
            te = [];
            tFlag = false;
            $target = null;
          }
        }
      });

    }
    function registerFunction(funcName) {
      return funcName();
    }
    function initPanels(name) {
      const $tabs = $this.children();
      $tabs.filter(function(idx, ele){
        $(ele).children().removeClass('active').prop('disabled', true);
        return $(ele).attr('data-tab') == name;
      }).map(function(idx, ele){
        $(ele).children().addClass('active');
      });
      const $panels = $container.children();
      $panels.map(function(idx, ele){
        if ( $(ele).hasClass('current') ) {
          $(ele).addClass('stay');
        }
        $(ele).removeClass('current prev next');
      });
    }
    function slidePanel(name, dir) {
      const $panels = $container.children();
      const $targetPanel = $container.find('.panel[data-tab="'+name+'"]');
      if (dir) {
        $targetPanel.addClass('prev');
      }
      const $prevPanel = $targetPanel.prev()[0] ? $targetPanel.prev() : $panels.last();
      const $nextPanel = $targetPanel.next()[0] ? $targetPanel.next() : $panels.first();
      fixedCenterTab(name, true);
      $container.addClass('anim');
      return $targetPanel.animate({'left': 0}, 200, 'easeInOutCubic', function(){
        $prevPanel.addClass('prev');
        $nextPanel.addClass('next');
        $container.children().removeClass('stay');
        $targetPanel.addClass('current').removeClass('prev').removeAttr('style');
        $this.children().map(function(idx, ele){
          $(ele).children().prop('disabled', false);
        });
      }).promise();
    }
    function fixedCenterTab(tabName ,animation = false) {
      // if (tabName == 'HOME') {
      //   $.pictFrame.fade();
      // } else {
      //   $.pictFrame.stop();
      // }
      const $targetTab = $this.children('[data-tab="'+tabName+'"]');
      const $centerTab = $targetTab.filter(function(idx, ele){
        const tabWidth = $(ele).outerWidth();
        const offsetLeft = $(ele).offset().left;
        if (animation) {
          return offsetLeft > 0 && offsetLeft + tabWidth > 0;
        }
        return offsetLeft > 0;
      });
      const offsetLeft = $centerTab[0].offsetLeft;
      const firstScLeft = offsetLeft - ($(window).width() - $centerTab.outerWidth()) / 2;
      if (animation) {
        $wrapTabs.animate({scrollLeft: firstScLeft}, 200, function(){
          let tabWidth = 0;
          if ($wrapTabs[0].scrollLeft > tabsWidth) {
            tabWidth = firstDetach();
          } else {
            tabWidth = lastDetach();
          }
          $wrapTabs[0].scrollLeft = firstScLeft + tabWidth;
        });
      } else {
        $wrapTabs[0].scrollLeft = firstScLeft;
      }
    }
    function firstDetach() {
      const $firstTab = $this.children().first().detach();
      $this.append($firstTab);
      return $firstTab.outerWidth() * -1;
    }
    function lastDetach() {
      const $lastTab = $this.children().last().detach();
      $this.prepend($lastTab);
      return $lastTab.outerWidth();
    }
    function getPageX(e) {
      var pageX = 0;
      if (e.originalEvent.touches) {
        pageX = e.originalEvent.touches[0].pageX;
      } else {
        pageX = e.pageX;
      }
      return pageX;
    }
    function getPageY(e) {
      var pageY = 0;
      if (e.originalEvent.touches) {
        pageY = e.originalEvent.touches[0].pageY;
      } else {
        pageY = e.pageY;
      }
      return pageY;
    }
    function calcscrollPos() {
      window.plimo.fusionPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $('.current .blk_consultation').outerHeight(true) - $(window).height() + 58;
      window.plimo.sectionFooterPos = $('.current').innerHeight() - $('.current .section_footer').outerHeight() - $(window).height();
    }
  };

})( jQuery );
